import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/admin/billing")({
  beforeLoad: () => {
    throw redirect({
      to: "/admin/clients",
    });
  },
});
